export const PUBLIC_HEADER_OFFSET = 96;

export function LandingSnapSection({
  children,
  id,
  minHeightClass = "",
}: {
  children: React.ReactNode;
  id?: string;
  minHeightClass?: string;
}) {
  return (
    <div
      id={id}
      className={`${minHeightClass} scroll-mt-24 lg:scroll-mt-28 outline-none`}
    >
      {children}
    </div>
  );
}
